"use strict";
// packages/types/src/auditChecklistItem.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChecklistItemStatus = void 0;
var ChecklistItemStatus;
(function (ChecklistItemStatus) {
    ChecklistItemStatus["NOT_CHECKED"] = "NOT_CHECKED";
    ChecklistItemStatus["SATISFACTORY"] = "SATISFACTORY";
    ChecklistItemStatus["NON_CONFORMITY"] = "NON_CONFORMITY";
    ChecklistItemStatus["OBSERVATION"] = "OBSERVATION";
})(ChecklistItemStatus || (exports.ChecklistItemStatus = ChecklistItemStatus = {}));
